import { getWindowLocation } from './browser';

/**
 * @type {import('./index.d').isTagPage}
 */
export const isTagPage = (tags) => {
  if (tags && tags.length > 0) return true;
  return false;
};

/**
 * @type {import('./index.d').isCollectionPage}
 */
export const isCollectionPage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'collection';
  }

  return context?.app?.generalSettings?.page === 'collection';
};

/**
 * @type {import('./index.d').isSearchPage}
 */
export const isSearchPage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'search';
  }

  return context?.app?.generalSettings?.page === 'search';
};

/**
 * @type {import('./index.d').isCartPage}
 */
export const isCartPage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'cart';
  }

  return context?.app?.generalSettings?.page === 'cart';
};

/**
 * @type {import('./index.d').isProductPage}
 */
export const isProductPage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'product';
  }

  return context?.app?.generalSettings?.page === 'product';
};

/**
 * @type {import('./index.d').isHomePage}
 */
export const isHomePage = (context) => {
  if (!context) {
    return window.boostWidgetIntegration?.generalSettings?.page === 'index';
  }

  return context?.app?.generalSettings?.page === 'index';
};

/**
 * @type {import('./index.d').isPageType}
 */
export const isPageType = () => {
  return window.location.pathname.indexOf('/collections/types') > -1 ? true : false;
};

/**
 * @type {import('./index.d').isVendorPage}
 */
export const isVendorPage = () => {
  return window.location.pathname.indexOf('/collections/vendors') > -1 ? true : false;
};

/**
 * Get current page
 * @type {import('./index.d').getCurrentPage}
 */
export const getCurrentPage = () => {
  let currentPage = '';

  switch (true) {
    case isCollectionPage():
      currentPage = 'collection_page';
      break;

    case isSearchPage():
      currentPage = 'search_page';
      break;

    case isProductPage():
      currentPage = 'product_page';
      break;

    case isCartPage():
      currentPage = 'cart_page';
      break;

    case isHomePage():
      currentPage = 'home_page';
      break;

    default:
      break;
  }

  return currentPage;
};

/**
 * @type {import('./index.d').isBadUrl}
 */
export const isBadUrl = (url) => {
  try {
    if (!url) {
      url = getWindowLocation().search;
    }
    var urlParams = decodeURIComponent(url).split('&');
    var isXSSUrl = false;
    if (urlParams.length > 0) {
      for (var i = 0; i < urlParams.length; i++) {
        var param = urlParams[i];
        isXSSUrl = isBadSearchTerm(param);
        if (isXSSUrl) break;
      }
    }
    return isXSSUrl;
  } catch {
    return true;
  }
};

/**
 * Checks if the given term is a bad search term containing potential XSS vulnerabilities.
 * @type {import('./index.d').isBadSearchTerm}
 */
export const isBadSearchTerm = (term) => {
  if (typeof term == 'string') {
    term = term.toLowerCase();
    // List of known DOM events and other potential XSS indicators
    var domEvents = [
      'script',
      'alert',
      'onabort',
      'popstate',
      'afterprint',
      'beforeprint',
      'beforeunload',
      'blur',
      'canplay',
      'canplaythrough',
      'change',
      'click',
      'contextmenu',
      'copy',
      'cut',
      'dblclick',
      'drag',
      'dragend',
      'dragenter',
      'dragleave',
      'dragover',
      'dragstart',
      'drop',
      'durationchange',
      'ended',
      'error',
      'focus',
      'focusin',
      'focusout',
      'fullscreenchange',
      'fullscreenerror',
      'hashchange',
      'input',
      'invalid',
      'keydown',
      'keypress',
      'keyup',
      'load',
      'loadeddata',
      'loadedmetadata',
      'loadstart',
      'mousedown',
      'mouseenter',
      'mouseleave',
      'mousemove',
      'mouseover',
      'mouseout',
      'mouseout',
      'mouseup',
      'offline',
      'online',
      'pagehide',
      'pageshow',
      'paste',
      'pause',
      'play',
      'playing',
      'progress',
      'ratechange',
      'resize',
      'reset',
      'scroll',
      'search',
      'seeked',
      'seeking',
      'select',
      'show',
      'stalled',
      'submit',
      'suspend',
      'timeupdate',
      'toggle',
      'touchcancel',
      'touchend',
      'touchmove',
      'touchstart',
      'unload',
      'volumechange',
      'waiting',
      'wheel',
      'load',
    ];
    const potentialEventRegex = new RegExp(domEvents.join('=|on'));
    // Detect actual JavaScript function calls
    const isAlert = (term.match(/alert\(/g) || []).length;
    const isConsoleLog = (term.match(/console\.log\(/g) || []).length;
    const isExecCommand = (term.match(/execCommand/g) || []).length;
    const isCookie = (term.match(/document\.cookie/g) || []).length;
    const isJavascript = (term.match(/j.*a.*v.*a.*s.*c.*r.*i.*p.*t/g) || []).length;

    // Detect HTML tags (more specific - must have tag name after < or before >)
    const hasHtmlTags = /<\w+|<\/\w+|\w+>/g.test(term);
    const isMetaTag = (term.match(/<meta/gi) || []).length;
    const isPotentialEvent = potentialEventRegex.test(term);

    // XSS-specific patterns (not just any < or >)
    const xssRegex =
      /\x3Cscript|<script|<\/script|<img[\s\S]*?src|<iframe|<\/iframe|<object|<embed|<applet|on\w+\s*=|javascript:|data:text\/html|&#[xX][0-9a-fA-F]+;/gi;
    const isXssTerm = xssRegex.test(term);

    if (
      hasHtmlTags ||
      isAlert ||
      isConsoleLog ||
      isExecCommand ||
      isCookie ||
      isJavascript ||
      isPotentialEvent ||
      isMetaTag ||
      isXssTerm
    ) {
      return true;
    }
  }
  return false;
};
